var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnPaymentUpdated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 94.784,
    height: 95.251,
    viewBox: "0 0 94.784 95.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "circle",
    x: 0,
    y: 0,
    width: 94.784,
    height: 95.251,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-payment-updated",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cc"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#circle)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "circle-2",
    "data-name": "circle",
    cx: 38.392,
    cy: 38.626,
    rx: 38.392,
    ry: 38.626,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1638",
    "data-name": "Ellipse 1638",
    cx: 2.1,
    cy: 2.118,
    rx: 2.1,
    ry: 2.118,
    transform: "translate(41.535 49.216)",
    fill: "#49a9f5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1639",
    "data-name": "Ellipse 1639",
    cx: 2.1,
    cy: 2.118,
    rx: 2.1,
    ry: 2.118,
    transform: "translate(48.339 49.216)",
    fill: "#49a9f5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1640",
    "data-name": "Ellipse 1640",
    cx: 2.1,
    cy: 2.118,
    rx: 2.1,
    ry: 2.118,
    transform: "translate(55.143 49.216)",
    fill: "#49a9f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16606",
    "data-name": "Group 16606",
    transform: "translate(15.123 26.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12303",
    "data-name": "Path 12303",
    d: "M0,0s.15,1.436,2.3,3.147C4.675,5.029,5.3,4.828,10.991,4.6c6.158-.243,14.764,2.55,15.633,4.068H.017S-.009.07,0,0Z",
    transform: "translate(8.673 0) rotate(90)",
    fill: "#0eb4d0",
    opacity: 0.175
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17230",
    "data-name": "Group 17230",
    transform: "translate(64.313 56.817) rotate(180)",
    opacity: 0.467
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12303-2",
    "data-name": "Path 12303",
    d: "M0,0S.182,1.436,2.731,3.147C5.536,5.029,6.277,4.828,13.015,4.6c7.291-.243,17.482,2.55,18.511,4.068H.021S-.011.07,0,0Z",
    transform: "translate(8.673 0) rotate(90)",
    fill: "#0eb4d0",
    opacity: 0.175
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1131",
    "data-name": "Line 1131",
    x2: 21.632,
    transform: "translate(21.665 38.171)",
    fill: "none",
    stroke: "#49a9f5",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1132",
    "data-name": "Line 1132",
    x2: 45.768,
    transform: "translate(17.196 32.22)",
    fill: "none",
    stroke: "#49a9f5",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17155",
    "data-name": "Rectangle 17155",
    width: 47.913,
    height: 33.181,
    rx: 7.12,
    transform: "translate(15.944 24.465)",
    fill: "none",
    stroke: "#347cb5",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "dots",
    transform: "translate(4.082 6.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16132",
    "data-name": "Group 16132",
    transform: "translate(0 12.846)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1262",
    "data-name": "Ellipse 1262",
    cx: 0.719,
    cy: 0.722,
    rx: 0.719,
    ry: 0.722,
    transform: "translate(68.346 31.266)",
    fill: "#e7e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1263",
    "data-name": "Ellipse 1263",
    cx: 0.719,
    cy: 0.722,
    rx: 0.719,
    ry: 0.722,
    transform: "translate(4.637 0)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1264",
    "data-name": "Ellipse 1264",
    cx: 0.719,
    cy: 0.722,
    rx: 0.719,
    ry: 0.722,
    transform: "translate(0 27.993)",
    fill: "#97d3f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16131",
    "data-name": "Group 16131",
    transform: "translate(32.305 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1265",
    "data-name": "Ellipse 1265",
    cx: 0.719,
    cy: 0.722,
    rx: 0.719,
    ry: 0.722,
    transform: "translate(7.56 58.701)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1266",
    "data-name": "Ellipse 1266",
    cx: 0.719,
    cy: 0.722,
    rx: 0.719,
    ry: 0.722,
    transform: "translate(44.904)",
    fill: "#97d3f1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1267",
    "data-name": "Ellipse 1267",
    cx: 0.719,
    cy: 0.722,
    rx: 0.719,
    ry: 0.722,
    transform: "translate(0 8.453)",
    fill: "#e7e6e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icn-green-check",
    transform: "translate(47.635 9.942)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1431",
    "data-name": "Ellipse 1431",
    fill: "#499f51",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.962,
    cy: 14.083,
    rx: 13.962,
    ry: 14.083,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.962,
    cy: 14.083,
    rx: 12.462,
    ry: 12.583,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M5825.15,585.983l3.688,4.282,8.14-8.179",
    transform: "translate(-5817.279 -572.185)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPaymentUpdated);
export default __webpack_public_path__ + "static/media/icn-payment-updated.cf8c500df8ecda05540f8cde272a8d12.svg";
export { ForwardRef as ReactComponent };